import axios from 'axios';
import Spotify_constant from './Spotify_constant';
import apiLogger from '../apiLogger';

let token_obj = null;
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
    refreshSubscribers.push(cb);
};

const onTokenRefreshed = (newToken) => {
    refreshSubscribers.forEach((cb) => cb(newToken));
    refreshSubscribers = [];
};

const getRefreshedToken = async () => {
    try {
        const params = new URLSearchParams();
        params.append("grant_type", "client_credentials");
        params.append("client_id", Spotify_constant.SPOTIFY_CLIENT_ID);
        params.append("client_secret", Spotify_constant.SPOTIFY_CLIENT_SECRET);
        const response = await axios.post(
            Spotify_constant.ENDPOINT_SPOTIFY.AUTH_TOKEN,
            params,
            {
                baseURL: Spotify_constant.SPOTIFY_BASE_URL_1,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    // Optional: you can include the cookie from cURL if really needed, but it’s not mandatory
                    // "Cookie": "__Host-device_id=..."
                },
            }
        );
        //console.log("getRefreshedToken Response : ",response?.data);
        token_obj = response?.data;
        return token_obj?.access_token;
    } catch (err) {
        console.error("Token refresh failed", err);
        throw err;
    }
};

export const Spotify_axios_adapter = axios.create({
    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

Spotify_axios_adapter.interceptors.request.use(
    async (config) => {
        if (config.baseURL === Spotify_constant.SPOTIFY_BASE_URL_1) {
            
        } else {
            if (!token_obj?.access_token) {
                const access_token = await getRefreshedToken();
                config.headers['Authorization'] = `Bearer ${access_token}`;
            } else {
                config.headers['Authorization'] = `Bearer ${token_obj?.access_token}`;
            }
        }
        return apiLogger.request(config);
    },
    (error) => apiLogger.error(error)
);

Spotify_axios_adapter.interceptors.response.use(
    (response) => apiLogger.response(response),
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const newToken = await getRefreshedToken();
                    isRefreshing = false;
                    onTokenRefreshed(newToken);
                } catch (err) {
                    isRefreshing = false;
                    return apiLogger.error(err);
                }
            }

            return new Promise((resolve) => {
                subscribeTokenRefresh((token) => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    resolve(Spotify_axios_adapter(originalRequest));
                });
            });
        }

        return apiLogger.error(error);
    }
);
